import React from 'react';

export const ShippingEco = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 52.18 61.8"
      width="52px"
      {...props}
    >
      <g>
        <g>
          <circle cx="26.09" cy="30.87" r="19.01" fill="#6ea5b5" />
        </g>
        <path
          fill="#26375f"
          d="M52.18 30.88a26 26 0 00-16-24.06 1 1 0 00-1.33.54 1 1 0 00.54 1.34 24 24 0 01-8.48 46.21l2.83-2a.95.95 0 10-1.11-1.53l-5.41 3.93a1 1 0 00-.39.69.92.92 0 00.28.74L28 61.53a.91.91 0 00.66.27.95.95 0 00.67-1.61L26.09 57a26.11 26.11 0 0026.09-26.12z"
        />
        <path
          fill="#26375f"
          d="M29.71 5.18l-4.9-4.9a1 1 0 00-1.34 0 1 1 0 000 1.34l3.18 3.18h-.56a26.1 26.1 0 00-10.73 49.87 1 1 0 00.42.09 1 1 0 00.42-1.95 24.05 24.05 0 019.89-46l-3.03 2.26a.95.95 0 00.56 1.71.91.91 0 00.56-.18l5.42-4a1 1 0 00.38-.7.93.93 0 00-.27-.72z"
        />
        <g>
          <g>
            <path
              fill="#bad641"
              d="M19.69 37.44a10.7 10.7 0 010-13.47c5-5.65 8.21-1.73 14.88-6.28 1.1 4.24 4.7 20.39-9.49 21.65a7.6 7.6 0 01-5.39-1.9z"
            />
          </g>
          <path
            fill="#26375f"
            d="M36.49 16.51a1.34 1.34 0 00-2-.77 15 15 0 01-7.56 2.65c-2.71.34-5.5.69-8.74 4.34l-.06.08a12.83 12.83 0 00-.52 15.42c-3.62 6.24-3.32 10-3.31 10.05a1.33 1.33 0 001.31 1.11h.22a1.33 1.33 0 001.1-1.48c0-.31 0-8.53 13.62-20.93a1.32 1.32 0 00.09-1.88 1.34 1.34 0 00-1.92-.1 62.13 62.13 0 00-9.57 10.73 11 11 0 01-.92-2.28 10 10 0 011.95-9c2.55-2.86 4.43-3.1 7-3.42a17.78 17.78 0 007.11-2.09c1 4.61 1.72 11.47-1.34 15.82-1.7 2.4-4.43 3.78-8.14 4.1a1.33 1.33 0 00-1.21 1.45 1.33 1.33 0 001.4 1.21h.12c4.53-.4 7.92-2.15 10.08-5.22 4.07-5.83 2.56-14.9 1.29-19.79z"
          />
        </g>
      </g>
    </svg>
  );
};
